// 招师代理页

import axios from '../utils/fetch';

export const checkUser = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/checkUser', options);
};

export const getLinks  = (options) => {
  return axios.getSign('/api/zmbiz-teacher-h5-api/agent/v2/getLinks', options);
};

export const agentRegister  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/register', options);
};

export const bindOpenId  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/bindOpenId', options);
};

export const findPassword  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/findPassword', options);
};

export const agentRecommend  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/agentRecommend', options);
};

export const getActivityInfo  = (options) => {
  return axios.getSign('/api/zmbiz-teacher-h5-api/agent/v2/getActivityInfo', options);
};

export const getLinkInfo  = (options) => {
  return axios.getSign('/api/zmbiz-teacher-h5-api/agent/v2/getLinkInfo', options);
};

export const generateRecommendLink  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/generateRecommendLink', options);
};

export const getPayInfo  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/getPayInfo', options);
};

export const profitYearDetail  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/profitYearDetail', options);
};

export const profitMonthDetail  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/profitMonthDetail', options);
};

export const recommendDetail  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/recommendDetail', options);
};

export const recommendCount  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/recommendCount', options);
};

export const getProvinces  = (options) => {
  return axios.getSign('/api/zmbiz-teacher-h5-api/agent/v2/getProvinces', options);
};

export const getAllCitys  = (options) => {
  return axios.getSign('/api/zmbiz-teacher-h5-api/agent/v2/getAllCitys', options);
};

export const savePayInfo  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/savePayInfo', options);
};

export const getDictByGroupCode  = (options) => {
  return axios.getSign('/api/zmbiz-teacher-h5-api/agent/v2/getDictByGroupCode', options);
};

export const getShareInfo  = (options) => {
  return axios.getSign('/api/zmbiz-teacher-h5-api/agent/v2/getShareInfo', options);
};

export const agentMonthRecommend  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/agentMonthRecommend', options);
};

export const queryAgentMsg  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/queryAgentMsg', options);
};

export const checkAgent  = (options) => {
  return axios.getSign('/api/zmbiz-teacher-h5-api/agent/v2/checkAgent', options);
};

export const supply  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/quickRegister', options);
};

export const getCName  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/getCName', options);
};

export const loginAndRegister  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/loginAndRegister', options);
};

export const getCTeachers  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/getCTeachers', options);
};

export const handAssign  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/handAssign', options);
};

export const getChannelUrl  = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v2/getChannelUrl', options);
};
